module.exports = __webpack_public_path__ + "assets/img/kid_register_with_panda.13bb8144.png";